/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import Vue from 'vue'
import Antd, { Checkbox } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
import Menudigui from './components/MenuDigui/index.vue'
// import './plugins/click-away'

import http from './api/index'
Vue.prototype.$http = http;

import './scss/app.scss';

import permission from './directive/permission'
Vue.use(permission)

Vue.use(Antd);

import store from './store'; // 引入 Vuex Store

Vue.config.productionTip = false

//设置全局函数
Vue.prototype.$filterOption = (input, option) => {
  return (
    option.componentOptions.children[0].text
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
  );
}

// Adding template layouts to the vue components.
Vue.component("menu-digui", Menudigui);
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);

import DepartmentSelect from './components/DepartmentSelect/DepartmentSelect.vue';
Vue.component('DepartmentSelect', DepartmentSelect);

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
VueViewer.setDefaults({
  title: false,
})
Vue.use(VueViewer)

import { Tree, Button, Cascader, DatePicker, ColorPicker, CheckboxGroup } from 'element-ui';
Vue.use(Tree).use(Button).use(Cascader).use(DatePicker).use(ColorPicker).use(CheckboxGroup).use(Checkbox)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')